import React from 'react';
import {
  Box, CircularProgress, Paper, Typography
} from '@mui/material';
import { Trans } from '@lingui/react';
import { MODEL_DRAW_WIDTH } from 'config';

const CLOSED_DRAWER_RAIL_WIDTH = 80;

interface StopeFillLoadingOverlayProps {
  drawerOpen: boolean;
}

const StopeFillLoadingOverlay = ({ drawerOpen }: StopeFillLoadingOverlayProps) => (
  <Box
    sx={{
      position: 'absolute',
      top: 'var(--stopes-toolbar-height, 0px)',
      bottom: 0,
      left: 0,
      right: drawerOpen ? `var(--stopes-drawer-width, ${MODEL_DRAW_WIDTH}px)` : CLOSED_DRAWER_RAIL_WIDTH,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      pointerEvents: 'none',
      zIndex: 10,
    }}
  >
    <Paper
      elevation={3}
      sx={{
        display: 'flex', alignItems: 'center', gap: 2, px: 3, py: 2,
      }}
    >
      {/* disableShrink: the rotation alone keeps spinning while the main thread is busy. */}
      <CircularProgress size={28} disableShrink />
      <Typography variant="body2">
        <Trans id="Loading...">Loading...</Trans>
      </Typography>
    </Paper>
  </Box>
);

export default StopeFillLoadingOverlay;
